<template>
  <div class="wrap">
    <div class="box">
      <!-- <div class="revenue-header">
        <div class="seach-box">
          <span class="time">时间</span>
          <div class="select">
            <el-select
              v-model="seachCondition.quarter"
              placeholder="请选择"
              @change="chagneDateType"
            >
              <el-option
                v-for="item in quarterList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-date-picker
              v-model="seachCondition.date"
              :type="datetype"
              placeholder="选择日期"
              value-format="yyyy/MM/dd"
              :clearable="false"
            >
            </el-date-picker>
          </div>
          <el-button @click="seachData" type="primary" style="margin-left:10px"
            >查询</el-button
          >
        </div>
      </div> -->
      <div class="revenue-main">
        <div class="revenue-main-show">
          <div class="show-box">
            <div class="show-box-title">当年总体情况</div>
            <div class="show-box-money">{{ data.incomeAndExpend }}</div>
          </div>
          <div class="show-box">
            <div class="show-box-title">当年营收</div>
            <div class="show-box-money">{{ data.income.total }}</div>
            <div class="monrybox"></div>
          </div>
          <div class="show-box">
            <div class="show-box-title">当年支出</div>
            <div class="show-box-money">{{ data.expend.trusteeship }}</div>
            <div class="monrybox"></div>
          </div>
        </div>
        <div class="revenue-main-show" style="margin-top:10px;">
          <div class="show-box">
            <div class="show-box-title">上月总体情况</div>
            <div class="show-box-money">{{ monthData.incomeAndExpend }}</div>
          </div>
          <div class="show-box">
            <div class="show-box-title">上月营收</div>
            <div class="show-box-money">{{ monthData.income.total }}</div>
            <div class="monrybox"></div>
          </div>
          <div class="show-box">
            <div class="show-box-title">上月支出</div>
            <div class="show-box-money">{{ monthData.expend.trusteeship }}</div>
            <div class="monrybox"></div>
          </div>
        </div>
        <div class="revenue-chart">
          <div class="chart-box">
            <div class="chart-box-item">
              <div class="item-title">当月托管收支总情况</div>
              <Echarts :datas="data" height="80%" kid="incomeAndExpendData"></Echarts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Echarts from "@/components/page/definition/echartExpert.vue";
import requesApi from "./index";
import dateTool from '@/utils/dateTool';
export default {
  data () {
    return {
      data: "",
      monthData: '',
      quarterList: [{ name: "年", id: "1" }],
      seachCondition: {
        quarter: "1",
        date: new Date()
      },
      datetype: "year"
    };
  },
  components: {
    Echarts
  },
  created () { },
  mounted () {
    this.seachData();
    const thatDate = new Date()
    let date = new Date(thatDate.getFullYear(), thatDate.getMonth() - 1, 1)
    requesApi
      .getDataForProprietor(2, dateTool.format(date, 'yyyy/MM/dd') + ' 00:00:00', 0, -1)
      .then(res => {
        this.monthData = res;
      });
  },
  watch: {},
  methods: {
    chagneDateType (i) {
      // i==1?this.datetype='year':this.datetype='month'
      this.datetype = i == 1 ? "year" : "month";
    },
    seachData () {
      this.getData(
        this.seachCondition.quarter,
        this.seachCondition.date,
        0,
        -1
      );
    },
    getData (dateType, time, companyId, status) {
      let vm = this;
      requesApi
        .getDataForProprietor(dateType, time, companyId, status)
        .then(res => {
          vm.data = res;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  color: #000000;
  .box {
    width: 100%;
    height: 100%;
    padding: 14px;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: #ffffff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .revenue-header {
      .seach-box {
        display: flex;
        align-items: center;
        text-align: left;
        .time {
          margin-right: 10px;
        }
        .select {
          margin-right: 10px;
        }
      }
    }
    .revenue-main {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      flex: 1;
      .revenue-main-show {
        display: flex;
        .show-box {
          background: #eee;
          flex: 1;
          margin-left: 10px;
          padding: 10px;
          border-radius: 4px;
          .show-box-title {
            font-weight: 600;
            text-align: left;
          }
          .show-box-money {
            font-weight: 700;
            font-size: 20px;
            padding-top: 10px;
            padding-bottom: 25px;
          }
          .monrybox {
            display: flex;
            justify-content: space-between;
          }
        }
      }
      .revenue-chart {
        flex: 1;
        .chart-box {
          height: 100%;
          .chart-box-item {
            height: 100%;
            padding: 10px;
            margin-top: 10px;
            margin-left: 10px;
            background: #eee;
            border-radius: 4px;
            flex: 1;
            .item-title {
              text-align: left;
              font-weight: 600;
              font-size: 16px;
              padding-bottom: 5px;
            }
          }
        }
        .chart-box-item {
          padding: 10px;
          margin-top: 10px;
          margin-left: 10px;
          background: #eee;
          border-radius: 4px;
          flex: 1;
          .item-title {
            text-align: left;
            font-weight: 600;
            font-size: 16px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
.pageNew {
  text-align: right;
  padding: 14px 0px 0px 0px;
}
.nc ::v-deep .el-input {
  width: 197px !important;
}
.ztWrap {
  overflow: hidden;
  white-space: normal;
}
.flexbox {
  display: flex;
}
</style>
